import { useDispatch } from 'react-redux';
import { alertActions } from '@actions';
import { conversationsService } from '@services';
import { handleApiError } from '@helpers/api';
import { useConversations, useTranslation } from '@hooks';

// Shared assign flow for the header quick control and the details drawer: both
// surfaces stay in sync through the same active-conversation and feed updates.
export const useAssignConversation = ({ setActiveConversation, filterRef }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { updateConversationInFeedAndReturn } = useConversations();

    return async (conversationId, userId) => {
        try {
            const conversation = await conversationsService.assign(conversationId, { userId });
            setActiveConversation(prev => (prev?.id === conversation.id ? { ...prev, ...conversation } : prev));
            updateConversationInFeedAndReturn(conversation, filterRef.current, true);
            dispatch(alertActions.success(t('alertMessages.updateSuccess')));
        } catch (error) {
            handleApiError(error);
        }
    };
};
